import format from '../../lib/formatDate'

const formatDate = (date, formateText) => {
  return format(date, formateText)
}
export default {
  formatDate
}



// WEBPACK FOOTER //
// ./src/lib/filters/index.js